import React from "react";
import {formatCurrency} from "../../../../helpers";
import {Container, ITextProps} from "../../../../ui";
import {FormattedDate, KeyValueField} from "../../../components";
import {AccountExternal, AccountSwitcherDetails} from "../../../declarations";

export interface IAccountMainDetails {
  account?: AccountExternal | AccountSwitcherDetails;
  size?: ITextProps["size"];
  gap?: string;
  latest_dpd?: number;
}

export const AccountMainDetails = ({account, size, gap = "3px"}: IAccountMainDetails) => {
  if (!account) {
    return null;
  }
  return (
    <Container fullWidth sx={{alignItems: "start", gap: gap}}>
      <KeyValueField
        field={"Amount owed"}
        value={formatCurrency(account.total_balance)}
        textTransform={"none"}
        {...(size && {size})}
      />
      {account.current_creditor && (
        <KeyValueField
          field={"Current creditor"}
          value={account.current_creditor}
          textTransform={"none"}
          nowrap={false}
          {...(size && {size})}
        />
      )}
      <KeyValueField
        field={"Original creditor"}
        value={account.original_creditor}
        textTransform={"none"}
        nowrap={false}
        {...(size && {size})}
      />
      {"latest_dpd" in account && account.latest_dpd && (
        <KeyValueField textTransform="" field={"Days past due"} value={account.latest_dpd} {...(size && {size})} />
      )}
      {account.origination_date && (
        <KeyValueField
          field={"Open date"}
          value={<FormattedDate date={account.origination_date} />}
          textTransform={"none"}
          {...(size && {size})}
        />
      )}
      {account.external_account_id && (
        <KeyValueField
          textTransform=""
          field={"Account number"}
          value={account.external_account_id}
          {...(size && {size})}
        />
      )}
      <KeyValueField
        field={"Reference number"}
        value={account.public_id}
        textTransform={"none"}
        {...(size && {size})}
      />
      {"product" in account && account.product && (
        <KeyValueField field={"Product"} value={account.product} textTransform={"none"} {...(size && {size})} />
      )}
    </Container>
  );
};
